import styled from "styled-components"

import {LatoBold} from "@irati/ui/src/global/fonts"
import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"


export default styled.td`
  &&& {
    border-color: ${greys.mediumLight};
    vertical-align: middle;
    border-top: none;
    border-bottom: 1px solid ${greys.lightest};
    padding-right: ${padding.medium};
  }

  ${(props) => (props.bold && LatoBold)}

  ${({right}) => right && `
    text-align: right;
  `}
`
